export default {
    inject: [ 'sharedState' ],
    computed: {
            color() {
                return this.sharedState.mainColor;
            },
            textColor() {
                return this.color + '__text' ;
            },
            textColorHover() {
                return this.color + '__text--hover' ;
            },
            borderColor() {
                return this.color + '__border' ;
            },
            bgColor() {
                return this.color + '__bg' ;
            },
            bgColorHover() {
                return this.color + '__bg--hover' ;
            },
            bgMessages() {
                return this.color + '__bg--messages';
            },
            borderMessages() {
                return this.color + '__border--messages';
            }
            // bgMedium() {
            //     return this.color + '__bg--medium';
            // }
        }
    }